<app-ark-container
  [future]="dataObservable"
  [titleTemplate]="title"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onGridDataResolved($event[0])"
  (onFailure)="onFailure($event[0])"
>
</app-ark-container>
<ng-template #title>
  <div nz-row class="consensus-header">
    <div nz-col nzSpan="12" class="title header-3">
      Consensus Template
    </div>
  </div>
</ng-template>
<ng-template #loading>
  <div class="grid-container">
    <ul nz-menu style="border: none">
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text"> Consensus Template could not be loaded.</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div *ngIf="hasError" class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>

  <div
    class="grid-container"
    *ngIf="!hasError && consensusTableData && consensusTableData.length"
  >
    <div id="consensus-template-container">
      <nz-table
        data-test="consensus-template-grid"
        [nzData]="consensusTableData"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
      >
        <thead>
          <tr>
            <th colspan="1" class="progressed-tab">Processed Tabs</th>
            <th colspan="1" class="progress-bar" nzWidth="130px"></th>
            <th colspan="2" class="column-border">Forecasted</th>
            <th colspan="2" class="column-border">Non-Forecasted</th>
            <th colspan="1" class="column-border">Total in Tab</th>
            <th colspan="1" class="column-border">Notes</th>
          </tr>
          <tr>
            <th class="progressed-tab">&nbsp;</th>
            <th class="progress-bar">
              <!-- add scale here -->
              <img [src]="assets + '/scale.png'" />
            </th>
            <th class="column-border">Excluded</th>
            <th>Used</th>
            <th class="column-border">Inferred</th>
            <th>Blank</th>
            <th class="column-border">&nbsp;</th>
            <th class="column-border">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-row [ngForOf]="consensusTableData">
            <tr
              (click)="onRowSelection(row)"
              [ngClass]="{
                'highlight-row': row.selected
              }"
            >
              <td class="progressed-tab">{{ row.name }}</td>
              <td class="progress-bar">
                <app-consensus-bar [data]="row"></app-consensus-bar>
              </td>
              <td class="column-border">{{ row.forecast_excluded }}</td>
              <td>{{ row.forecast_used }}</td>
              <td class="column-border">{{ row.n_forecast_inferred }}</td>
              <td>{{ row.n_forecast_blank }}</td>
              <td class="column-border">{{ row.total }}</td>
              <td class="column-border">{{ row.notes }}</td>
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
      <div class="footer">
        <span class="legendOuterSpan">
          <ul class="legend">
            <li><span class="excludedLegend"></span> % Excluded</li>
            <li><span class="usedLegend"></span> % Used</li>
            <li><span class="inferredLegend"></span> % Inferred</li>
            <li><span class="blankLegend"></span> % Blank</li>
          </ul>
        </span>
        <span class="percentMattersNotSpan">
          Percentages shown when hovering over bars may not add up to 100% due
          to rounding.
        </span>
      </div>
    </div>
  </div>
</ng-template>
